import * as types from './types';
import {
   createReducer,
} from '../../utils/reducerHelper';

import initialState from './initial-state';

const reducersMap = {
   [types.UPDATE_CURRENT_START]: (state) => {
      return {
         ...state,
         isNotificationInProgress: true,
      };
   },
   [types.UPDATE_CURRENT_FAILED]: (state) => {
      return {
         ...state,
         isNotificationInProgress: false,
      };
   },
   [types.UPDATE_CURRENT_COMPLETED]: (state, action) => {
      const { data, metaDataDefault } = action.payload;

      return {
         ...state,
         isNotificationInProgress: false,
         current: data,
         metaDataDefault,
      };
   },
   [types.SAVE_CURRENT_START]: (state) => ({
      ...state,
      isNotificationInProgress: true,
   }),
   [types.SAVE_CURRENT_FAILED]: (state) => ({
      ...state,
      isNotificationInProgress: false,
   }),
   [types.SAVE_CURRENT_COMPLETED]: (state) => ({
      ...state,
      isNotificationInProgress: false,
   }),

   [types.FETCH_NOTIFICATIONS_START]: (state) => ({
      ...state,
      isNotificationsListLoading: true,
   }),
   [types.FETCH_NOTIFICATIONS_COMPLETED]: (state, action) => ({
      ...state,
      isNotificationsListLoading: false,
      notificationsList: action.payload.notifications,
      notificationsStats: action.payload.stats,
   }),
   [types.FETCH_NOTIFICATIONS_FAILED]: (state) => ({
      ...state,
      isNotificationsListLoading: false,
   }),

   [types.MARK_READ_START]: (state) => ({
      ...state,
      isMarkReadInProgress: true,
   }),
   [types.MARK_READ_COMPLETED]: (state, action) => {
      const readIds = action.payload.ids;
      const updatedList = state.notificationsList.map((n) => {
         if (readIds.includes(n.id)) {
            return { ...n, status: 1 };
         }
         return n;
      });
      const newUnread = updatedList.filter((n) => n.status === 0 || n.status === '0').length;
      return {
         ...state,
         isMarkReadInProgress: false,
         notificationsList: updatedList,
         notificationsStats: {
            ...state.notificationsStats,
            unread: newUnread,
            read: state.notificationsStats.total - newUnread,
         },
      };
   },
   [types.MARK_READ_FAILED]: (state) => ({
      ...state,
      isMarkReadInProgress: false,
   }),

   [types.MARK_ALL_READ_START]: (state) => ({
      ...state,
      isMarkReadInProgress: true,
   }),
   [types.MARK_ALL_READ_COMPLETED]: (state) => {
      const updatedList = state.notificationsList.map((n) => ({ ...n, status: 1 }));
      return {
         ...state,
         isMarkReadInProgress: false,
         notificationsList: updatedList,
         notificationsStats: {
            ...state.notificationsStats,
            unread: 0,
            read: state.notificationsStats.total,
         },
      };
   },
   [types.MARK_ALL_READ_FAILED]: (state) => ({
      ...state,
      isMarkReadInProgress: false,
   }),
};

export default createReducer(initialState)(reducersMap);
